import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button } from '../Button/index.js';
import { i18n } from '../../i18n/translate.js';
import { sanitizeUrl } from '@braintree/sanitize-url';
import GeneralErrorImg from '../../images/general_error.svg.js';
import NotFoundImg from '../../images/not_found.svg.js';
import NoAccessImg from '../../images/no_access.svg.js';
import MaintenanceImg from '../../images/maintenance.svg.js';
var ErrorPage = /*#__PURE__*/function (_React$Component) {
  function ErrorPage() {
    var _this;
    _classCallCheck(this, ErrorPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ErrorPage, [].concat(args));
    _defineProperty(_this, "renderErrorMessages", function () {
      return /*#__PURE__*/React.createElement("ul", {
        className: "errors"
      }, _this.props.errors.map(function (error, index) {
        if (typeof error === 'string' || /*#__PURE__*/React.isValidElement(error)) {
          return /*#__PURE__*/React.createElement("li", {
            key: "error[".concat(index, "]"),
            className: "error-message"
          }, error);
        } else {
          return null;
        }
      }));
    });
    _defineProperty(_this, "renderTechnicalContact", function () {
      if (!_this.props.techContact) return null;
      var _this$props$techConta = _this.props.techContact,
        name = _this$props$techConta.technical_contact_name,
        phone = _this$props$techConta.technical_contact_phone,
        email = _this$props$techConta.technical_contact_email;
      return name || phone || email ? /*#__PURE__*/React.createElement("div", {
        className: "technical-contact p-20"
      }, /*#__PURE__*/React.createElement("p", {
        className: "m-b-10"
      }, i18n.t('Please email or call your technical contact if this error persists')), name && /*#__PURE__*/React.createElement("strong", {
        className: "m-r-15"
      }, name), phone && /*#__PURE__*/React.createElement("span", {
        className: "m-r-15"
      }, phone), email && /*#__PURE__*/React.createElement("a", {
        href: sanitizeUrl("mailto:".concat(email))
      }, email)) : null;
    });
    _defineProperty(_this, "renderBackButton", function () {
      var _this$props = _this.props,
        backButtonUrl = _this$props.backButtonUrl,
        backButtonText = _this$props.backButtonText;
      return backButtonUrl ? /*#__PURE__*/React.createElement(Button, {
        label: backButtonText || i18n.t('Back to Learner Dashboard'),
        icon: "angle-left",
        style: "primary",
        className: "btn-back",
        href: backButtonUrl
      }) : null;
    });
    return _this;
  }
  _inherits(ErrorPage, _React$Component);
  return _createClass(ErrorPage, [{
    key: "imageUrl",
    get: function get() {
      var imageUrl = '';
      switch (this.props.type) {
        case 'general_error':
          imageUrl = GeneralErrorImg;
          break;
        case 'not_found':
          imageUrl = NotFoundImg;
          break;
        case 'no_access':
          imageUrl = NoAccessImg;
          break;
        case 'maintenance':
          imageUrl = MaintenanceImg;
          break;
        default:
          imageUrl = GeneralErrorImg;
      }
      return imageUrl;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "error-page-container"
      }, /*#__PURE__*/React.createElement("h2", null, this.props.title), this.props.errors && this.renderErrorMessages(), /*#__PURE__*/React.createElement("img", {
        src: this.imageUrl,
        alt: i18n.t('Error'),
        className: "img-error img-fluid"
      }), this.renderTechnicalContact(), this.renderBackButton());
    }
  }]);
}(React.Component);
ErrorPage.displayName = "ErrorPage";
export { ErrorPage };